import {gql} from 'apollo-angular';

export const ROOKIEDAY_REGISTER_SCHOLAR = gql`
  mutation rookiedayRegisterScholar($scholarData: InRookieDayScholar!) {
    rookiedayRegisterScholar(scholarData: $scholarData) {
      type
      message
    }
  }
`;
